module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/youtube-64c89565788688625bb86e3c89be6d6f.svg";